export default "__VITE_ASSET__BF0xNH2w__"